import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "INTL/en";
import ar from "INTL/ar";

// ========================================================
// Localisation Setup
// ========================================================

i18n.use(LanguageDetector).init({
  // we init with resources
  resources: {
    en: {
      translations: en
    },
    ar: {
      translations: ar
    }
  },
  fallbackLng: "en",
  debug: true,
  // have a common namespace used around the full app
  ns: ["translations"],
  defaultNS: "translations",
  keySeparator: false, // we use content as keys
  interpolation: {
    escapeValue: false, // not needed for react!!
    formatSeparator: ","
  },
  react: {
    wait: true
  }
});

export default i18n;

// The method we'll use instead of a regular string
const Strings = (name, params = {}) => {
  return i18n.t(name, params);
};

const ChangeLanguage = language => {
  i18n.changeLanguage(language);
};

export { Strings, ChangeLanguage };


// WEBPACK FOOTER //
// ./src/resources/i18n/i18n.js